var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTask(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99809 16H11.9981M7.99809 11H15.9981M7.50009 3.5C5.94409 3.547 5.01709 3.72 4.37509 4.362C3.49609 5.242 3.49609 6.657 3.49609 9.488V15.994C3.49609 18.826 3.49609 20.241 4.37509 21.121C5.25309 22 6.66809 22 9.49609 22H14.4961C17.3251 22 18.7391 22 19.6171 21.12C20.4971 20.241 20.4971 18.826 20.4971 15.994V9.488C20.4971 6.658 20.4971 5.242 19.6171 4.362C18.9761 3.72 18.0481 3.547 16.4921 3.5",
    stroke: "#626F86",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49609 3.75C7.49609 2.784 8.28009 2 9.24609 2H14.7461C15.2102 2 15.6553 2.18437 15.9835 2.51256C16.3117 2.84075 16.4961 3.28587 16.4961 3.75C16.4961 4.21413 16.3117 4.65925 15.9835 4.98744C15.6553 5.31563 15.2102 5.5 14.7461 5.5H9.24609C8.78197 5.5 8.33685 5.31563 8.00866 4.98744C7.68047 4.65925 7.49609 4.21413 7.49609 3.75Z",
    stroke: "#626F86",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTask);
export default __webpack_public_path__ + "static/media/task.f6effb81f71033860511f6ba50dfeb1a.svg";
export { ForwardRef as ReactComponent };